import StringTools from '@bm/string-tools'

export const setCookie = (cookieName, cookieValue, cookieOptions = {}) => {
  return cookieStore.set(Object.assign({}, cookieOptions, { name: cookieName, value: cookieValue }))
}

export const setCookieSync = (cookieName, cookieValue, cookieOptions = {}) => {
  let cookie = cookieName + '=' + cookieValue
  if (typeof cookieOptions.expires === 'number') {
    cookie += ';expires=' + new Date(cookieOptions.expires).toUTCString()
  }
  if (typeof cookieOptions.path === 'string' && cookieOptions.path.startsWith('/')) {
    cookie += ';path=' + StringTools.sanitizeString(cookieOptions.path)
  }
  document.cookie = cookie
}

export const removeCookie = (cookieName) => {
  return cookieStore.delete(cookieName)
}

export const removeCookieSync = (cookieName) => {
  setCookieSync(cookieName, '', { expires: 0 })
}

export const getAllCookies = () => {
  return cookieStore.getAll()
}

export const getAllCookiesSync = () => {
  return document.cookie.split(';')
      .map(cookie => {
        const cookieObj = cookie.trim().split('=')
        return {
          domain: null,
          expires: null,
          name: cookieObj[0],
          partitioned: false,
          path: null,
          sameSite: null,
          secure: null,
          value: cookieObj[1]
        }
      })
}

export const getCookie = (cookieName) => {
  return cookieStore.get(cookieName)
}

export const getCookieSync = (cookieName) => {
  return getAllCookiesSync().find(cookieData => cookieData.name === cookieName)
}

export const getCookieValue = (cookieName) => {
  return new Promise(resolve => {
    cookieStore.get(cookieName).then(cookie => { resolve(cookie ? cookie.value : null) })
  })
}

export const getCookieValueSync = (cookieName) => {
  const cookie = getCookieSync(cookieName)
  return cookie ? cookie.value : null
}

if (typeof cookieStore === 'undefined') {
  const listeners = []

  class CookieStore {
    constructor () {
      this.onchange = null
      const that = this
      const nativeCookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
      Object.defineProperty(Document.prototype, 'orgCookie', nativeCookieDesc);
      Object.defineProperty(Document.prototype, 'cookie', {
        enumerable: true,
        configurable: true,
        get() {
          return this.orgCookie
        },
        set(value) {
          this.orgCookie = value
          const event = new Event('Change')
          listeners.filter(listenerObj => listenerObj.event === 'change').forEach(listenerObj => { listenerObj.callback(event) })
          if (typeof that.onchange === 'function') {
            that.onchange(event)
          }
        }
      })
    }

    delete (name) {
      const options = typeof name === 'object' ? name : {}
      if (typeof name === 'string') {
        options.name = name
      }
      return new Promise((resolve, reject) => {
        if (!options.name) {
          reject()
          return
        }
        removeCookieSync(options.name)
        resolve()
      })
    }

    get (name) {
      const options = typeof name === 'object' ? name : {}
      if (typeof name === 'string') {
        options.name = name
      }
      return new Promise((resolve, reject) => {
        if (!options.name) {
          reject()
          return
        }
        resolve(getCookieSync(options.name))
      })
    }

    getAll (name) {
      const options = typeof name === 'object' ? name : {}
      if (typeof name === 'string') {
        options.name = name
      }
      return new Promise((resolve) => {
        const cookies = getAllCookiesSync().filter(cookie => { return !options.name || cookie.name === options.name })
        resolve(cookies)
      })
    }

    set (name, value) {
      const options = typeof name === 'object' ? name : {}
      if (typeof name === 'string' && typeof value !== 'undefined') {
        options.name = StringTools.sanitizeString(name)
        options.value = StringTools.sanitizeString(value)
      }
      return new Promise((resolve, reject) => {
        if (!options.name) {
          reject()
          return
        }
        setCookieSync(options.name, options.value, options)
        resolve()
      })
    }

    addEventListener (eventName, callback) {
      listeners.push({
        event: eventName,
        callback: callback
      })
    }

    removeEventListener (eventName, callback) {
      const found = listeners.find(listenerObj => listenerObj.event === eventName && listenerObj.callback === callback)
      if (found) {
        const index = listeners.indexOf(found)
        listeners.splice(index, 1)
      }
    }
  }
  window.cookieStore = new CookieStore()
  console.info('CookieStore API not available, polyfill loaded.')
}

export default {
  setCookie,
  setCookieSync,
  removeCookie,
  removeCookieSync,
  getAllCookies,
  getAllCookiesSync,
  getCookie,
  getCookieSync,
  getCookieValue,
  getCookieValueSync
}
